<button
  (click)="$event.stopPropagation(); showDropdown.set(true)"
  (mouseenter)="showDropdown.set(true)"
  (mouseleave)="showDropdown.set(false)"
  class="rounded-[5px] border border-gray-400 cursor-pointer flex flex-col"
  [style.backgroundColor]="bgBase()"
  [attr.aria-label]="'Wybierz język' | translate"
>
  <div class="flex items-center gap-[5px] px-2 py-1 lg:px-3 lg:py-1.5 lg:gap-2">
    <neopos-icon name="lang" class="text-base leading-none lg:text-2xl" />

    <div class="flex items-center lg:gap-1">
      <span class="text-[11px] lg:text-base leading-none">{{
        currentLang() | uppercase
      }}</span>

      <neopos-icon name="arrow-bottom" class="text-base leading-none" />
    </div>
  </div>

  @if (showDropdown()) { @for (lang of availableLangs(); track lang) { @if (lang
  !== currentLang()) {
  <button
    (click)="onChangeLanguage(lang)"
    class="flex items-center justify-center px-2 py-1 hover:bg-gray-200 cursor-pointer w-full text-left"
  >
    <span class="text-[11px] lg:text-base leading-none">
      {{ lang | uppercase }}
    </span>
  </button>
  } } }
</button>
